import React from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { reqMainPdAction } from '../../modules/hp/mainModule';
import ProdItem from '../common/prod/ProdItem';
import { Link, useHistory } from 'react-router-dom';
import {isMobileOnly} from 'react-device-detect';


const HpProdItemsBlock = styled.div`
    width: 100%;
    ${!isMobileOnly&&"max-width: 1176px"}; /* JP for responsive */
    margin: 0 auto;
    .hprod-section {
        ${isMobileOnly?`
            padding: 60px 0 80px;
        `:`
            padding: 100px 0 120px;
        `}
    }
    .section-title {
      ${isMobileOnly?`
            display:flex; align-items:center; justify-content:space-between;line-height:29px;height:29px; font-size: 20px;
            margin-left: 4vw;
            margin-bottom:0;                         
            a {
                padding:0 15px;
                position: unset;
                font-size: unset;
                img {width: 6px; height:12px;}
            }           
      `:`
          position: relative;
          margin-bottom: 30px;
          font-size: 30px;
          text-align: center;
      
      `}      
    }
    .best_item-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        //${isMobileOnly&&"margin-left:0"};
       ${isMobileOnly&&`
           margin:0 4vw;
           li:nth-last-of-type(1), li:nth-last-of-type(2) {margin-bottom:0;}
       `};
    }
`;

const HpProdList = () => {

    const dispatch = useDispatch();
    const history = useHistory();

    const { mainPdItems } = useSelector(
        ({ loadingReducer, mainReducer }) => ({
            loading: loadingReducer['main/MAIN_PD'],
            mainPdItems: mainReducer.mainPdItems,
        })
    );

    useEffect(() => {
        dispatch(reqMainPdAction());
    }, [dispatch])

    /**
     * 이미지 클릭 처리
     * @param {*} param
     */
    const handleImgClick = (param) => {
        // console.log("param : " + JSON.stringify(param));
        history.push("/prod?prodid=" + param.prdct_id)
    }

    if (mainPdItems === null || mainPdItems === undefined) {
        return <div />;
    }

    return (
        <HpProdItemsBlock>
            <div className="hprod-section">
                <div className="sz-wrap margin_b-30">
                    <div className="section-title">
                        <div><b>인기 견적</b> 상품은 어디?</div>
                        <Link to="/ct">{isMobileOnly&&<img src="/assets/images/icon/arrow_right.svg"/>}</Link>
                    </div>
                </div>

                <ul className="best_item-list clearfix">
                    {
                        /*메인PC나올때까지 임시 나오면 위에껄로 다시*/
                        mainPdItems.map((curitem, idx)=>{
                            if((!isMobileOnly||(isMobileOnly&&idx<20))){
                                return (<ProdItem
                                  key={curitem.prdct_id}
                                  img={curitem.repr_img}
                                  prodname={curitem.prdct_nm}
                                  sale_price={curitem.sale_price}
                                  prdct_price={curitem.prdct_price}
                                  brandname={curitem.brnd_han}
                                  isBrandShow={true}
                                  clickHandler={handleImgClick}
                                  brandid={curitem.brnd_id}
                                  prodinfo={curitem} />)
                            }
                          })
                    }
                    {isMobileOnly ? <div style={{height:'0px', margin: '0px', width:'44vw'}}></div> : ''}
                </ul>
            </div>
        </HpProdItemsBlock>
    );
};

export default HpProdList;
